import ProjectSession from "../../../model2/project/project-session";


export default function selectParent_CollapseAll(rootProjects:ProjectSession[]): void {


    const recursiveCollapse = (project:ProjectSession) => {

        project.treeIsExpandedProjectSelector = false

        _.map(project.treeChildren, (childProject: ProjectSession) => {
            recursiveCollapse(childProject)
        })

    }

    _.map(rootProjects, (project: ProjectSession) => {
        recursiveCollapse(project)
    })

}